/// <reference path="../definitions/QueryTs.d.ts" />
enum QueryTouchDirection {
    X =     1 << 1,
    Y =     1 << 2,
    Both =  X | Y
}

class QueryTouch {
    private readonly _element: IQueryElement;

    private _current?: QueryTouchDetails;
    private _lastMove: QueryTouchPoint[] = [];
    private readonly _recognizers: IQueryTouchRecognizer[] = [];

    constructor(element: IQueryElement) {
        this._element = element;
        element.on("touchstart", async(e: TouchEvent) => await this.touchStart(e));
        element.on("touchmove", async(e: TouchEvent) => await this.touchMove(e));
        element.on("touchend", async(e: TouchEvent) => await this.touchEnd(e));
    }

    addRecognizer(recognizer: IQueryTouchRecognizer) {
        this._recognizers.push(recognizer);
    }

    private _notRecognizeds: IQueryTouchRecognizer[] = [];
    private _isRecognizeds: IQueryTouchRecognizer[] = [];
    async touchStart(e: TouchEvent) {
        this._lastMove = this.getTouchPoints(e.touches);
        this._current = new QueryTouchDetails(this._lastMove);

        this._notRecognizeds = this._recognizers.concat();
        this._isRecognizeds = [];
    }
    async touchMove(e: TouchEvent) {
        if (this._current == null)
            throw "TouchStart wasn't called first";
        
        this._lastMove = this.getTouchPoints(e.touches);
        
        for(let x = 0; x < this._notRecognizeds.length; x++) {
            let item = this._notRecognizeds[x];
            let fulfilled = item.isFulfilled(this._current, new QueryTouchDetails(this._lastMove));
            
            if(fulfilled === true) {
                this._isRecognizeds.push(item);
                await item.onStart(this._current);
            }
            if(fulfilled !== null) {
                this._notRecognizeds.splice(x, 1);
                x--;
            }
        }

        if(this._isRecognizeds.length > 0) {
            for(let item of this._isRecognizeds) {
                await item.onMove(this._current, new QueryTouchDetails(this._lastMove));
            }
            e.preventDefault();
        }
    }
    async touchEnd(e: TouchEvent) {
        if (this._current == null)
            throw "TouchStart wasn't called first";
        
        for(let x of this._isRecognizeds) {
            await x.onStop(this._current, new QueryTouchDetails(this._lastMove));
        }
    }
    touchCancel() {

    }

    private getTouchPoints(list: TouchList) {
        let touches = [];
        for(let curr of list) {
            if(curr.pageX !== undefined && curr.pageY !== undefined)
                touches.push(new QueryTouchPoint(curr.pageX, curr.pageY));
        }
        return touches;
    }
}

